import { render, staticRenderFns } from "./ScoringView.vue?vue&type=template&id=e97c6de6&scoped=true"
import script from "./ScoringView.vue?vue&type=script&lang=js"
export * from "./ScoringView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97c6de6",
  null
  
)

export default component.exports